var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.67414 16.1886C12.9125 16.1886 16.3483 12.7885 16.3483 8.5943C16.3483 4.40008 12.9125 1 8.67414 1C4.43583 1 1 4.40008 1 8.5943C1 12.7885 4.43583 16.1886 8.67414 16.1886Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3125 14.1735L18.0866 17.9083",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupIcon);
export default __webpack_public_path__ + "static/media/LookupIcon.b5664292472d97987a2771a26e46077e.svg";
export { ForwardRef as ReactComponent };